import { fetchAssessmentChallenges } from '@actions/assessmentChallenges';
import {
    getAssessmentChallenges,
    getAssessmentChallengesFetchError,
    getAssessmentChallengesIsFetching,
} from '@selectors/assessmentChallenges';
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

const useFetchAssessmentChallenges = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAssessmentChallenges());
    }, [dispatch]);

    const assessmentChallenges = useSelector(getAssessmentChallenges);
    const isFetching = useSelector(getAssessmentChallengesIsFetching);
    const fetchError = useSelector(getAssessmentChallengesFetchError);

    return { assessmentChallenges: Object.values(assessmentChallenges), isFetching, fetchError };
};

export default useFetchAssessmentChallenges;
